import React from 'react'

export interface INavigationContainerProps {
  onRouteChange?: (prevRouteName?: string, newRouteName?: string) => void
  children?: React.ReactNode
}

export const NavigationContainer: React.FC<INavigationContainerProps> = ({ onRouteChange, children }) => <>{children}</>
